import * as Sentry from '@sentry/browser'
import { BrowserTracing } from '@sentry/tracing'

Sentry.init({
  dsn: gon.sentry_dsn,
  integrations: [
    new BrowserTracing()
  ],
  // パフォーマンス計測対象とするトラフィックの割合。0.1=全アクセスの10%
  tracesSampleRate: 0.1
})
